import axios from './axiosInterceptors';
import authHeader from "./authentification-header";

const API_URL = "/api/v1/delivery-orders/";

const searchDeliveryOrders = (formData) => {
    return axios.post(API_URL + 'search-do-ticket', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const getDoByDoNoAndDoItemNo = (formData) => {
    return axios.post(API_URL + 'get-do-by-pono', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const allActions = {
    searchDeliveryOrders,
    getDoByDoNoAndDoItemNo
};

export default allActions;